export const firebaseConfig = {
  apiKey: "AIzaSyBfHhueJ3kD6zYfSDGBCzer9qcjSa-5Q8g",
  authDomain: "you-can-do-it-gardening.firebaseapp.com",
  projectId: "you-can-do-it-gardening",
  storageBucket: "you-can-do-it-gardening.appspot.com",
  messagingSenderId: "1018875853470",
  appId: "1:1018875853470:web:e1a861226e1c3e4a75198f",
  measurementId: "G-0DJWTZTY6G"
}